import type { ParseKeys } from "i18next";
import { useTranslation } from "react-i18next";

/**
 * Error message shown directly under a form input; renders nothing when
 * the field is valid. `message` is a translation key (see validation.ts).
 * The input links to it with aria-describedby={`${id}-error`}.
 */
export function FieldError({ id, message }: { id: string; message?: string }) {
  const { t } = useTranslation();
  if (!message) return null;
  return (
    <p id={`${id}-error`} className="mt-1.5 text-sm text-red-600">
      {t(message as ParseKeys)}
    </p>
  );
}

/** Border and focus ring classes for an input, red when it has an error. */
export function inputBorderClass(hasError: boolean): string {
  return hasError
    ? "border-red-300 focus:ring-red-400"
    : "border-gray-200 focus:ring-blue-500";
}
